interface Props {
    className?: string;
}

const ButtonsBar: FC<Props> = ({ children, className = '' }) => (
    <div className={`buttons-bar clearfix ${className}`}>{children}</div>
);

export default ButtonsBar;
